import React from 'react'
import PropTypes from 'prop-types'

function ReportLink({ id, children, baseUrl }) {
  // Using template literals here.
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  const url = `${baseUrl}${id}`
  return <a href={url}>{children}</a>
}

ReportLink.propTypes = {
  id: PropTypes.string.isRequired,
  baseUrl: PropTypes.string,
  children: PropTypes.element.isRequired,
}

ReportLink.defaultProps = {
  baseUrl: '/reports/',
}

export default ReportLink
